// extracted by mini-css-extract-plugin
export default {"LogoContainer":"LogoContainer_LogoContainer__Dofji","Logo":"LogoContainer_Logo__bZ2e1"};